<script setup lang="ts">
import type { ModelRef } from "vue";

defineProps<{
  disabled?: boolean;
}>();

const { t } = useI18n();

const timezone: ModelRef<string | undefined> = defineModel<string>();

const timezoneList: string[] = Intl.supportedValuesOf("timeZone");
</script>

<template>
  <lxc-select
    v-model="timezone"
    :placeholder="t('input.timezone.placeholder')"
    :disabled="disabled"
    select-filter
    :select-search-placeholder="t('input.select.search.placeholder')"
    :select-no-result-text="t('input.select.search.noResults')"
  >
    <lxc-option
      v-for="(timezoneItem, index) in timezoneList"
      :key="index"
      :label="timezoneItem"
      :value="timezoneItem"
    />
  </lxc-select>
</template>
